import { Box, Flex, Text } from "@chakra-ui/react";

// Horizontal meter: total AI credits (the annual £ allowance, currency symbol
// stripped) vs credits used so far this year. Visible to everyone — unlike the
// £ figures elsewhere on this page (gated to ESG_ADMIN via AdminOnlyValue), a
// credit count carries no currency meaning so there's nothing sensitive to hide.
function CreditsAllowanceBar({ totalCredits, usedCredits }) {
  const pct = totalCredits ? Math.min(100, (usedCredits / totalCredits) * 100) : 0;

  return (
    <Box width="75%">
      <Flex justify="space-between" align="baseline" mb={2} flexWrap="wrap" gap={2}>
        <Text fontSize="body.m" fontWeight="600" color="gray.700">
          Annual AI Credits
        </Text>
        <Text fontSize="body.s" color="gray.600">
          <Text as="span" fontWeight="700" color="darkTeal">
            {usedCredits.toLocaleString()}
          </Text>{" "}
          of {totalCredits.toLocaleString()} credits used
        </Text>
      </Flex>
      <Box position="relative" h="14px" bg="gray.100" borderRadius="full" overflow="hidden">
        <Box h="100%" bg="lime" borderRadius="full" width={`${pct}%`} transition="width 0.3s ease" />
      </Box>
      <Text fontSize="body.xs" color="gray.500" mt={1.5}>
        {Math.round(pct)}% of this year's AI credit allowance used so far.
      </Text>
    </Box>
  );
}

export default CreditsAllowanceBar;
